import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, filter, fromEvent } from "rxjs";
import { ScreenWakeLockService } from "shared/util-screen";
import { classroomConnectionActions } from "../../public/state/classroom.actions";
import { startLessonActions } from "../../public/store/lesson.actions";

@Injectable()
export class ScreenWakeLockEffects {

    private readonly actions$ = inject(Actions);

    private readonly wakeLock = inject(ScreenWakeLockService);


    private visibilityChange$ = fromEvent(document, 'visibilitychange').pipe(
        filter(() => document.visibilityState === 'visible'),
    );


    readonly requestLock$ = createEffect(() => this.actions$.pipe(
        ofType(classroomConnectionActions.connectToClassroomSuccess, startLessonActions.startLessonSuccess),
        switchMap(() => this.wakeLock.requestLock()),
    ), { dispatch: false });

    readonly requestLockOnVisibilityChange$ = createEffect(() => this.visibilityChange$.pipe(
        switchMap(() => this.wakeLock.requestLock()),
    ), { dispatch: false });

    readonly releaseLock$ = createEffect(() => this.actions$.pipe(
        ofType(classroomConnectionActions.connectToClassroomFailed),
        switchMap(() => this.wakeLock.releaseLock()),
    ), { dispatch: false });

}
